import { useQuery } from 'react-query'
import { getScanInfo } from '../../api/case_plannings'

export function useScanInfoQuery(jobnumberId: number) {
  return useQuery(['scan_info', jobnumberId], () => getScanInfo(jobnumberId))
}
